<template>
  <AccountingPage title="Factures">
    <InvoicesTable/>
  </AccountingPage>
</template>

<script>
import AccountingPage from "@/accounting/components/AccountingPage.vue";
import InvoicesTable from "@/accounting/components/tables/InvoicesTable.vue";

export default {
  name: 'AccountingView',
  components: {
    InvoicesTable,
    AccountingPage,
  },
}
</script>
